import { render } from "./UeberUnsBox.vue?vue&type=template&id=fd63dae8"
import script from "./UeberUnsBox.vue?vue&type=script&lang=ts"
export * from "./UeberUnsBox.vue?vue&type=script&lang=ts"

import "./UeberUnsBox.vue?vue&type=style&index=0&id=fd63dae8&lang=scss"
script.render = render

export default script